// extracted by mini-css-extract-plugin
export default {"circle":"CircleCore_circle__sqEs4","circle_pink":"CircleCore_circle_pink__Hw-NM","circle_purple":"CircleCore_circle_purple__Fug09","circle_yellow":"CircleCore_circle_yellow__4nn2h"};